module.exports = __webpack_public_path__ + "img/home1.85236a02.png";